module.exports = __webpack_public_path__ + "img/Rolling-1s-200px_2.f27fcb12.svg";